import { AxiosResponse } from "axios";
import api from "../Interceptors/Interceptor";
import ApiResponse from "../Models/ApiResponse";
import ReferenceModel from "../Models/ReferenceModel";
import { ResourceLocation } from "../Constants/resourceLocations";

export interface IComment {
    uuid: string;
    body: string;
    createdAt?: string;
    createdBy?: ReferenceModel;
}

export interface ICreateCommentRequest {
    location: ResourceLocation;
    locationIdentifier: string;
    body: string;
}

export class CommentService {
    public async fetchByLocation(
        location: ResourceLocation,
        locationIdentifier: string
    ): Promise<AxiosResponse<ApiResponse<IComment[]>>> {
        return api.get("v1/comment/by-location", {
            params: { location, locationIdentifier },
        });
    }

    public async addComment(
        location: ResourceLocation,
        locationIdentifier: string,
        body: string
    ): Promise<AxiosResponse<ApiResponse<IComment>>> {
        return api.post("v1/comment", { location, locationIdentifier, body });
    }

    public async deleteComment(commentUuid: string): Promise<AxiosResponse<ApiResponse<boolean>>> {
        return api.delete(`v1/comment/${commentUuid}`);
    }
}
